var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 136,
    viewBox: "0 0 130 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7038_65040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7027 129.405C100.437 129.405 129.405 100.437 129.405 64.7027C129.405 28.9684 100.437 0 64.7027 0C28.9684 0 0 28.9684 0 64.7027C0 100.437 28.9684 129.405 64.7027 129.405Z",
    fill: "#EEEFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0014 11.7876C53.0014 11.7876 32.9539 17.8105 34.8468 49.5595V118.048H57.6476L53.0014 11.7876Z",
    fill: "url(#paint0_linear_7038_65040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6797 32.3515V130.696H94.3024V47.8389C94.3024 47.8389 97.1417 16.0898 76.3198 12.1319C76.3198 12.1319 50.6797 7.48573 50.6797 32.3515Z",
    fill: "url(#paint1_linear_7038_65040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.933 95.3335H49.5605V110.391H79.933V95.3335Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.402 135.084H92.8382L89.1384 120.285C89.1384 120.285 86.127 97.8285 101.614 97.4844C101.614 97.4844 109.616 103.077 111.767 116.327C111.853 116.327 113.574 126.824 113.402 135.084Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1607 135.084L44.914 123.899C44.914 123.899 49.8183 98.9472 34.417 98.603C34.417 98.603 23.2317 107.809 24.0921 135.084H42.1607Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4053 64.9609H57.6484V92.408H76.4053V64.9609Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3193 76.1462V64.9609H57.6484V81.0506C63.8434 80.8785 71.1568 79.76 76.3193 76.1462Z",
    fill: "#CBCBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7812 101.098C36.9972 94.5589 43.6224 92.8381 43.6224 92.8381L59.4539 86.9873H74.5971L93.9563 92.8381C93.9563 92.8381 100.581 94.5589 104.797 101.098H32.7812Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6556 123.383V135.084H97.4004L96.7121 121.49C95.9377 95.2475 98.8631 95.2475 98.8631 95.2475C96.1098 93.4407 93.8727 92.8384 93.8727 92.8384L78.6435 88.5363C78.6435 88.5363 75.374 102.733 62.726 102.733C62.726 102.733 53.0033 97.4846 55.6706 88.3643L43.6249 92.8384C43.6249 92.8384 38.8066 94.3011 34.4185 98.6031C34.3325 98.6892 36.4835 99.9798 36.6556 123.383Z",
    fill: "#B2B7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3843 67.112C77.782 68.5747 76.8356 69.9513 75.631 71.1559C72.5336 74.1673 68.8338 76.5765 64.8759 78.2973C59.9716 80.2762 52.5721 80.5343 48.7002 76.4904C45.5167 73.2209 43.7959 68.2305 42.4193 64.0145C39.752 55.7546 39.752 46.7203 40.4403 38.2023C40.6124 36.2233 40.7845 34.3304 41.1287 32.3515C44.2261 13.5946 60.2297 13.6806 60.2297 13.6806C72.2754 13.1644 83.3747 18.8431 85.1816 31.5771C85.8699 36.4815 84.9234 41.7299 84.7513 46.5482C84.5793 50.1619 84.1491 53.6896 82.9445 57.1312C81.7399 60.6589 79.847 63.7564 78.3843 67.112Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9336 52.9152C79.9336 52.9152 81.5684 46.29 86.6448 49.0433C86.6448 49.0433 88.9679 50.2479 87.3331 54.8081C87.3331 54.8081 84.924 61.3472 79.9336 58.938V52.9152Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2351 34.5026C38.3747 8.77643 62.8103 9.981 62.8103 9.981C86.7296 10.9274 87.9342 21.8546 87.9342 21.8546C90.8596 35.6212 86.6436 48.9575 86.6436 48.9575C81.5672 47.839 80.7068 54.6362 80.7068 54.6362C81.223 43.709 80.3626 43.1067 80.3626 43.1067C68.489 36.9118 58.6803 31.2331 42.3326 38.8047C42.3326 38.8047 39.3211 38.9768 39.3211 48.2692V34.5026H39.2351Z",
    fill: "url(#paint2_linear_7038_65040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4519 68.0586C43.4519 68.0586 46.5494 83.1157 56.7022 87.7619C38.8057 99.7216 34.6758 102.905 34.6758 102.905L34.9339 79.8462L43.4519 68.0586Z",
    fill: "url(#paint3_linear_7038_65040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0847 59.5405C82.0847 59.5405 83.0312 81.1368 44.5709 92.064C26.7605 98.9472 26.1582 109.874 26.1582 109.874C26.1582 109.874 67.1997 138.01 112.199 118.651C110.134 100.926 106.004 96.7102 93.9584 92.9244",
    fill: "url(#paint4_linear_7038_65040)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7038_65040",
    x1: 41.853,
    y1: 23.311,
    x2: 45.3246,
    y2: 94.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#603076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3661,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    stopColor: "#C92459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7038_65040",
    x1: 88.4897,
    y1: 45.1167,
    x2: 41.5643,
    y2: 142.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7038_65040",
    x1: 85.4666,
    y1: 42.0102,
    x2: 46.9423,
    y2: 25.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7038_65040",
    x1: 42.0986,
    y1: 23.2993,
    x2: 45.5702,
    y2: 94.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#603076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3661,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    stopColor: "#C92459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7038_65040",
    x1: 115.401,
    y1: 75.5287,
    x2: 53.4595,
    y2: 121.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7038_65040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.405,
    height: 135.084,
    rx: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.2e54581c244bb8c533e8da6bf8cc6546.svg";
export { ForwardRef as ReactComponent };